<template>
    <div>
        <div class="handle-box">
            <el-button type="primary" icon="el-icon-plus" @click="addRule">添加</el-button>
        </div>
        <el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header"
            :cell-style="centerStyle">
            <el-table-column prop="ID" label="ID" width="55" align="center"></el-table-column>
            <el-table-column prop="name" label="活动名称" width="200" show-overflow-tooltip
                header-align="center"></el-table-column>
            <el-table-column prop="shareName" label="分享标题" width="200" show-overflow-tooltip
                header-align="center"></el-table-column>
            <el-table-column prop="giftDesc" label="奖励描述" width="200" show-overflow-tooltip
                header-align="center"></el-table-column>
            <el-table-column prop="balanceQuantity" label="余额赠送（元）" width="120" show-overflow-tooltip
                header-align="center"></el-table-column>
            <el-table-column prop="pointQuantity" label="积分赠送" header-align="center" width="100"></el-table-column>
            <el-table-column prop="desc" label="描述" show-overflow-tooltip></el-table-column>
            <el-table-column prop="num" label="活动时间" width="310">
                <template #default="scope">
                    {{ rfcToTime(scope.row.startTime) }} 至 {{ rfcToTime(scope.row.endTime) }}
                </template>
            </el-table-column>
            <el-table-column label="启用状态" width="100" align="center">
                <template #default="scope">
                    <el-button type="text" :style="'color:' + [!(scope.row.status == 1) ? 'red' : '']">
                        {{ scope.row.status == 1 ? "启用" : "禁用" }}
                    </el-button>
                </template>
            </el-table-column>
            <el-table-column prop="CreatedAt" label="创建日期" show-overflow-tooltip header-align="center"
                :formatter="dateRfcHMS"></el-table-column>
            <el-table-column label="操作" width="240" align="center">
                <template #default="scope">
                    <el-button type="text" icon="el-icon-edit" @click="editRule(scope.row)">编辑
                    </el-button>
                    <el-button type="text" @click="showUserList(scope.row.ID, scope.row.name)" icon="el-icon-user">参与用户
                    </el-button>
                    <el-button type="text" style="color: red;" @click="deleteActivity(scope.row.ID)"
                        icon="el-icon-delete">删除
                    </el-button>
                </template>

            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination background layout="total, prev, pager, next" :current-page="query.page"
                :page-size="query.page_size" :total="pageTotal" @current-change="handlePageChange"></el-pagination>
        </div>
        <!-- 编辑弹出框 -->
        <el-dialog v-model="editVisible" :title="[form.code ? '编辑' : '添加'] + '平台活动福利'" @close="editVisible = false"
            :width="970">
            <el-form ref="form" :model="form" :rules="rules" label-width="130px">
                <el-form-item prop="name" label="活动名称：">
                    <el-input v-model="form.name" placeholder="请输入活动名称"></el-input>
                </el-form-item>
                <el-form-item prop="shareName" label="分享标题">
                    <el-input v-model="form.shareName" placeholder="请输入分享标题"></el-input>
                </el-form-item>
                <el-form-item prop="giftDesc" label="奖励描述">
                    <el-input v-model="form.giftDesc" placeholder="请输入奖励描述"></el-input>
                </el-form-item>
                <el-form-item prop="startTime" label="活动时间：">
                    <div class="block">
                        <el-date-picker v-model="timeArr" type="datetimerange" start-placeholder="活动开始时间"
                            :default-time="['0000-00-00 00:00:00', '3000-00-00 23:59:59']" end-placeholder="活动结束时间"
                            format="YYYY-MM-DD HH:mm:ss" date-format="YYYY/MM/DD ddd" time-format="A hh:mm:ss" />
                    </div>
                </el-form-item>
                <el-form-item label="发放用户：" prop="label">
                    <el-checkbox-group v-model="form.label">
                        <el-checkbox v-for="(item, index) in userTypeList" :key="index" :label="item" :value="item">
                            {{ item }}
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="活动图片：" prop="popupImageUrl">
                    <el-alert title="建议尺寸720（长）*590（宽）" type="success" style="margin-bottom: 10px;" />
                    <el-upload class="avatar-uploader pop-img" :show-file-list="false" :on-change="handleCoverChange"
                        list-type="picture-card" :auto-upload="false">
                        <img v-if="form.popupImageUrl" :src="form.popupImageUrl" class="pop-img">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="活动描述：" prop="desc">
                    <el-input type="textarea" v-model="form.desc" placeholder="请输入描述" style="height: 100px;"
                        resize="none"></el-input>
                </el-form-item>
                <el-form-item label="页面跳转：" prop="redirectUrl">
                    <p><el-tag type="primary">若选择【直接领取】，用户可通过点击首页弹框、福利中心的按钮直接领取奖励</el-tag></p>
                    <el-select v-model="form.redirectUrl" placeholder="请选择页面跳转" style="width: 300px;" clearable>
                        <el-option v-for="(item, index) in redirectUrlList" :key="index" :label="item.label"
                            :value="item.value" @click="typeChange(item)">
                        </el-option>
                    </el-select>
                    <el-input v-if="isShowParam" v-model="Urlparam" :placeholder="parameterDesc"
                        style="width: 300px;margin-left: 10px;"></el-input>
                </el-form-item>
                <el-divider content-position="left" border-style="color: #ccc;margin:20px 0"
                    v-if="isReward">赠送福利</el-divider>

                <el-form-item prop="code" label="已选优惠券：" style="position: relative;" v-if="isReward">
                    <div class="coupon-list" v-if="selectCoupon.length > 0">
                        <p class="coupon-name" v-for="item in selectCoupon" :key="item.id">{{ item.name }} <span
                                style="color: #aaa;">{{ ' x' + item.num }}</span></p>
                    </div>
                    <p v-else>暂未选择优惠券</p>
                    <el-button type="primary" style="position: absolute;right: 50px;top: 0;"
                        @click="showCouponList">选择优惠券</el-button>
                </el-form-item>
                <el-form-item prop="code" label="已选择卡券：" style="position: relative;" v-if="isReward">
                    <!-- <div class="coupon-list"> -->
                    <p style="color: red;">暂未开通</p>
                    <!-- </div>
                    <el-button type="primary" style="position: absolute;right: 50px;top: 0;">选择优惠券</el-button> -->
                </el-form-item>

                <el-form-item prop="code" label="余额赠送（元）：" v-if="isReward">
                    <el-input-number v-model="form.balanceQuantity" :controls="false" style="width: 50%;"
                        placeholder="请输入余额数量"></el-input-number>
                    <el-tag type="primary">该余额类型为平台通用余额</el-tag>
                </el-form-item>

                <el-form-item label="积分赠送数量：" v-if="isReward">
                    <el-input-number v-model="form.pointQuantity" :controls="false" style="width: 50%;"
                        placeholder="请输入积分数量"></el-input-number>
                </el-form-item>

                <el-form-item prop="status" label="是否启用：">
                    <el-switch v-model="form.status"></el-switch>
                </el-form-item>
                <div style="text-align: right; margin-top: 10px">
                    <el-button @click="editVisible = false">取消</el-button>
                    <el-button type="primary" @click="saveEdit">保存</el-button>
                </div>
            </el-form>
        </el-dialog>
        <el-dialog title="选择优惠券" v-model="couponVisible" width="80%">
            <el-table :data="couponList" border class="table" ref="couponTable" header-cell-class-name="table-header"
                :cell-style="centerStyle" style="height: 50vh !;overflow-y: scroll;">
                <el-table-column type="selection" width="55">
                    <template #default="scope">
                        <el-checkbox v-model="scope.row.is_select" @change="handleSelectionChange()"></el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column prop="num" label="数量" width="155" align="center">
                    <template #default="scope">
                        <el-input-number v-model="scope.row.num" :min="1" :max="999" @change="handleSelectionChange()"
                            v-if="scope.row.is_select" style="width: 100px !important; " :controls="false" />
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="ID" width="55" align="center"></el-table-column>
                <el-table-column prop="name" label="优惠券名称" width="200" show-overflow-tooltip
                    header-align="center"></el-table-column>
                <el-table-column prop="" label="状态" show-overflow-tooltip header-align="center">
                    <template #default="scope">
                        <span>{{ scope.row.overdu ? '已过期' : '未过期' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="memo" label="优惠券说明" show-overflow-tooltip
                    header-align="center"></el-table-column>
                <el-table-column prop="" label="使用门槛" width="100" header-align="center">
                    <template #default="scope">
                        <span>{{ scope.row.meet_amount / 100 }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="优惠金额" width="100" header-align="center">
                    <template #default="scope">
                        <span>{{ scope.row.use_amount / 100 }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="门店" show-overflow-tooltip header-align="center">
                    <template #default="scope">
                        <span>{{ scope.row.store_id === 0 ? '平台' : scope.row.store_name }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="优惠券可使用时间" show-overflow-tooltip header-align="center">
                    <template #default="scope">
                        <span>{{ rfcToTime(scope.row.start_time) }} 至 {{ rfcToTime(scope.row.end_time) }}</span>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <el-dialog :title="userNum" v-model="userVisible" width="70%">
            <el-table :data="userList" border class="table" ref="multipleTable" header-cell-class-name="table-header"
                :cell-style="centerStyle">
                <el-table-column prop="ID" label="ID" width="55" align="center">
                    <template #default="scope">
                        <span>{{ scope.row.user.id }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="称呼" width="200" show-overflow-tooltip header-align="center">
                    <template #default="scope">
                        <span>{{ scope.row.user.real_name || scope.row.user.nickname }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="手机号码" width="200" show-overflow-tooltip header-align="center">
                    <template #default="scope">
                        <span>{{ scope.row.user.phone }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="pointQuantity" label="积分奖励" width="200" show-overflow-tooltip
                    header-align="center">
                </el-table-column>
                <el-table-column prop="balanceQuantity" label="余额奖励" width="200" show-overflow-tooltip
                    header-align="center">
                </el-table-column>
                <el-table-column prop="couponIds" label="优惠券ID" width="200" show-overflow-tooltip header-align="center">
                    <template #default="scope">
                        <span>{{ scope.row.couponIds ? scope.row.couponIds.join('、') : '无' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="voucherIds" label="卡券ID" width="200" show-overflow-tooltip header-align="center">
                    <template #default="scope">
                        <span>{{ scope.row.voucherIds ? scope.row.voucherIds.join('、') : '无' }}</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="下单量" label="手机号码" show-overflow-tooltip header-align="center"></el-table-column> -->
            </el-table>
            <div class="pagination">
                <el-pagination background layout="total, prev, pager, next" :current-page="user_query.page"
                    :page-size="user_query.pageSize" :total="userPageTotal"
                    @current-change="handleUserPageChange"></el-pagination>
            </div>
        </el-dialog>
        <!--  裁剪图片弹框 -->
        <el-dialog v-model="dialogVisible">
            <img ref="previewImage" :src="previewImage" style="width: 100%;" />
            <cropper ref="cropper" :src="previewImage" @ready="handleCropperReady" @cropmove="handleCropMove"
                style="width: 900px;" @cropend="handleCropEnd" />
            <div class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="getCroppedImage">裁剪并上传</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getPopPolite, createPopPolite, updatePopPolite, getPopUsers, deletePopPolite, getUserLabels } from "@/api/activity";
import { getCoupon } from "@/api/coupon";
import { rfcToTime } from "@/utils/defaultTime";
import { redirectUrlList } from "../constant/redirectUrl";
import { dataURLtoFile } from "@/utils/compress";
import { upload } from "@/api/editor";
import 'cropperjs/dist/cropper.css';
import Cropper from 'cropperjs';
export default {
    name: "ActivityPop",
    data() {
        return {
            query: {
                page: 1,
                pageSize: 10,
            },
            rules: {
                name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
                desc: [{ required: true, message: '请输入活动描述', trigger: 'blur' }],
                label: [{ required: true, message: '请选择发放用户', trigger: 'blur' }]
                // startTime: [{ required: true, message: '请选择活动时间', trigger: 'blur' }],
                // popupImageUrl: [{ required: true, message: '请上传活动图片', trigger: 'blur' }]
            },
            tableData: [{
                ID: 1
            }],
            pageTotal: 0,
            form: {
                id: 0,
                status: 1, //规则状态（1-启用，2-停用）
                name: '', //规则名称
                desc: '', //规则描述
                shareName: '',
                giftDesc: '',
                minQuantity: null, //最小数量
                maxQuantity: null, //最大数量
                couponIds: [],//卡券列表
                voucherIds: [],//优惠券列表
                startTime: '',//活动开始
                endTime: '',//活动结束
                balanceQuantity: '',//余额赠送量
                pointQuantity: '',//积分赠送量
                label: [],
                popupImageUrl: '',
                redirectUrl: ''
            },
            actTitle: "新增", // 弹框标题
            editVisible: false, // 弹框开启状态
            userList: [],
            userPageTotal: 0,
            userNum: '用户列表（总0人）',
            couponVisible: false,
            timeArr: [],
            couponList: [],
            selectCoupon: [],
            user_query: {
                page: 1,
                pageSize: 10,
                popupGiftId: null
            },
            userVisible: false,
            userTypeList: [],
            dialogVisible: false,
            previewImage: '',
            isShowParam: false,
            Urlparam: null,
            parameterDesc: '',
            editUrlparam: '',
            editRedirectUrl: '',
            isReward: true
        };
    },
    computed: {
        rfcToTime() {
            return rfcToTime
        },
        redirectUrlList() {
            return redirectUrlList
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.getData();
        },
        dateRfcHMS: function (row, column) {
            const date = row[column.property];
            if (date === undefined || date === 0) {
                return "";
            }
            return new Date(+new Date(date) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
        },

        centerStyle() {
            return 'text-align:center'
        },
        getData() {
            getPopPolite(this.query).then(res => {
                this.tableData = res.data.list
                this.pageTotal = res.data.total
            })
        },

        // 触发搜索按钮
        // handleSearch() {
        //     this.getData()
        // },

        // 获取用户类型列表
        getUserTypeList() {
            getUserLabels().then(res => {
                this.userTypeList = res.data
            })
        },

        // 分页导航
        handlePageChange(val) {
            this.query.page = val
            this.getData()
        },

        // 添加弹框
        addRule() {
            this.getCouponList()
            this.getUserTypeList()
            this.form = {}
            this.actTitle = "添加"
            this.form.id = null
            this.form.label = []
            this.timeArr = []
            this.selectCoupon = []
            this.isShowParam = false
            this.Urlparam = null
            this.editVisible = true
        },

        // 编辑弹框
        editRule(row) {
            this.getCouponList()
            this.getUserTypeList()
            this.actTitle = "编辑"
            this.form.id = row.ID
            this.form.name = row.name
            this.form.shareName = row.shareName
            this.form.couponIds = row.couponIds
            this.form.label = row.label
            this.form.voucherIds = row.voucherIds
            this.form.startTime = rfcToTime(row.startTime)
            this.form.endTime = rfcToTime(row.endTime)
            this.form.desc = row.desc
            this.form.status = row.status == 1 ? true : false
            this.form.pointQuantity = row.pointQuantity
            this.form.balanceQuantity = row.balanceQuantity
            this.form.popupImageUrl = row.popupImageUrl
            if (row.redirectUrl != '') {
                this.isReward = false
                let redirectUrlArr = row.redirectUrl.split('?')
                this.form.redirectUrl = redirectUrlArr.length > 1 ? redirectUrlArr[0] + '?' : row.redirectUrl
                if (redirectUrlArr.length > 1) {
                    this.editRedirectUrl = redirectUrlArr[0] + '?'
                    this.Urlparam = redirectUrlArr[1]
                    this.editUrlparam = redirectUrlArr[1]
                    if (this.Urlparam) {
                        this.isShowParam = true
                    }
                }
            }else{
                this.isReward = true
            }
            this.form.giftDesc = row.giftDesc
            this.timeArr = [new Date(row.startTime), new Date(row.endTime)]
            setTimeout(() => {
                this.editVisible = true
            }, 500)
        },

        showCouponList() {
            this.couponVisible = true
        },

        saveEdit() {
            this.$refs.form.validate(valid => {
                if (!valid) return
                if (!this.isReward) {
                    this.form.pointQuantity = null
                    this.form.balanceQuantity = null
                    this.form.couponIds = []
                    this.form.voucherIds = []
                }
                if (!!this.form.id && this.form.id != 0) {
                    if (this.isShowParam && this.Urlparam == '') {
                        Element.Message.error('请输入参数')
                        return
                    } else if (this.isShowParam && this.Urlparam != '') {
                        this.form.redirectUrl = this.form.redirectUrl + this.Urlparam
                    }
                    this.form.status = this.form.status ? 1 : 2
                    this.form.startTime = this.timeArr[0].toISOString()
                    this.form.endTime = this.timeArr[1].toISOString()
                    updatePopPolite(JSON.stringify(this.form)).then(res => {
                        if (res.code === 0) {
                            this.$message.success('保存成功')
                            this.editVisible = false
                            this.getData()
                        }
                    })
                } else {
                    if (this.isShowParam && this.Urlparam == '') {
                        Element.Message.error('请输入参数')
                        return
                    } else if (this.isShowParam && this.Urlparam != '') {
                        this.form.redirectUrl = this.form.redirectUrl + this.Urlparam
                    }
                    this.form.status = this.form.status ? 1 : 2
                    this.form.startTime = this.timeArr[0].toISOString()
                    this.form.endTime = this.timeArr[1].toISOString()
                    createPopPolite(JSON.stringify(this.form)).then(res => {
                        if (res.code === 0) {
                            this.$message.success('保存成功')
                            this.editVisible = false
                            this.getData()
                        }
                    })
                }
            })
        },
        // 获取优惠券列表
        getCouponList() {
            getCoupon({ page: 1, page_size: 9999, store_id: 0 }).then(res => {
                this.couponList = res.data
                this.selectCoupon = []
                if (this.form.couponIds && this.form.couponIds.length > 0) {
                    // 使用 Map 存储每个 id 的数量
                    const idCounts = new Map();
                    this.form.couponIds.forEach(id => {
                        idCounts.set(id, (idCounts.get(id) || 0) + 1);
                    });
                    this.couponList.forEach(coupon => {
                        const count = idCounts.get(coupon.id) || 0;
                        coupon.is_select = count > 0;
                        coupon.num = count;
                        if (coupon.is_select) {
                            this.selectCoupon.push(coupon);
                        }
                    });
                } else {
                    this.couponList.forEach(coupon => {
                        coupon.is_select = false;
                        coupon.num = 0;
                    });
                }
            })
        },

        // 选择优惠券
        handleSelectionChange() {
            // this.couponList.forEach(coupon => {
            //     if(row.id === coupon.id){
            //         coupon.num = 1
            //     }
            // });
            this.selectCoupon = this.couponList.filter(coupon => coupon.is_select);
            this.form.couponIds = this.selectCoupon.flatMap(item => Array(item.num).fill(item.id));
        },
        // 参与用户
        showUserList(id, name) {
            this.userVisible = true
            this.getUserList(id)
            this.userTypeName = name
        },
        getUserList(id) {
            this.user_query.popupGiftId = id
            getPopUsers(this.user_query).then(res => {
                if (res.code === 0) {
                    this.userList = res.data.list
                    this.userNum = this.userTypeName + '（总' + res.data.total + '人）'
                    this.userPageTotal = res.data.total
                }
            })
        },
        // 用户列表分页导航
        handleUserPageChange(val) {
            this.user_query.page = val
            this.getUserList(this.user_query.popupGiftId)
        },
        // 删除活动
        deleteActivity(id) {
            this.$confirm("确定要删除吗？", "删除提示", {
                type: "warning"
            }).then(() => {
                deletePopPolite(JSON.stringify({ id })).then(res => {
                    if (res) {
                        this.$message.success('删除成功')
                    }
                    this.getData()
                })
            })
        },
        // 活动图片
        handleCoverChange(file) {
            this.handlePictureCardPreview(file)
            this.file = file
            this.dialogVisible = true
        },

        // 裁剪
        handlePictureCardPreview(file) {
            this.previewImage = file.url;
            this.fileName = file.name
            this.dialogVisible = true;
            this.$nextTick(() => {
                if (!this.cropper) {
                    this.cropper = new Cropper(this.$refs.previewImage, {
                        aspectRatio: 59 / 72, // 可调整裁剪比例
                        viewMode: 1, // 裁剪框外的图片是否可见
                        dragMode: 'move', // 裁剪模式
                    });
                } else {
                    this.cropper.replace(file.url);
                }
            });
        },

        getCroppedImage() {
            let img = this.cropper.getCroppedCanvas().toDataURL('image/jpeg')
            let newImg = dataURLtoFile(img, this.fileName)
            let formData = new FormData();
            formData.append("file", newImg.file);
            upload(formData).then(res => {
                if (res.url === undefined) {
                    this.file = {}
                }
                let that = this
                that.form.popupImageUrl = res.url
            })
            this.dialogVisible = false;
        },
        // 判断是否要传参
        typeChange(row) {
            this.isReward = true
            if (row.value != '') {
                this.isReward = false
            }
            if (row.isNeedparameter) {
                this.isShowParam = true
                this.parameterDesc = row.parameterDesc
                if (row.value != this.editRedirectUrl) {
                    this.Urlparam = ''
                } else {
                    this.Urlparam = this.editUrlparam
                }
            } else {
                this.isShowParam = false
            }
        },
    }
};
</script>
<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.mr10 {
    margin-right: 10px;
}

.el-input,
.el-input-number {
    width: 220px;
    margin-right: 10px;
}

.el-select {
    width: 220px;
}

.el-dialog__body .el-select,
.el-dialog__body .el-input,
.el-dialog__body .el-input-number,
.el-dialog__body .el-textarea {
    width: 240px !important;
    text-align: left;
}

.box {
    margin: 0 auto;
}

.box .el-input {
    width: 60%;
}

.rowstyle {
    width: 100%;
    margin: 0 auto;
    padding-left: 15%;
}

.el-row {
    margin-bottom: 10px;
}

.el-col {
    border-radius: 4px;

}

.row-bg {
    padding: 5px 0;
    background-color: #f9fafc;
}

.grid-content {
    border-radius: 4px;
    min-height: 24px;
    text-align: center;
    line-height: 24px;
}

.tip {
    font-size: 12px;
    color: red;
}

.w350 {
    width: 350px;
}

.w250 {
    width: 250px;
}

.coupon-list {
    display: flex;
    flex-wrap: wrap;
    max-height: 100px;
    padding: 10px;
    overflow-y: scroll;
    padding-right: 50px;
}

.coupon-name {
    border-left: 4px solid #27a778;
    padding-left: 10px;
    margin-right: 30px;
    height: 10px;
    line-height: 10px;
    margin-top: 5px;
    font-size: 15px;
}

/deep/ .cropper-bg {
    width: 900px !important;
}

/deep/ .cropper-modal {
    width: 900px;
}

/deep/ .cropper-wrap-box {
    width: 900px;
}

::v-deep .el-upload--picture-card {
    width: 295px !important;
    height: 360px !important;
}

.dialog-footer {
    margin-top: 30px;
}

.pop-img {
    width: 295px;
    height: 360px;
}
</style>